var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{directives:[{name:"editable",rawName:"v-editable",value:(_vm.cms),expression:"cms"}],class:[_vm.name, _vm.spacing],style:(_vm.mainCssVars),attrs:{"id":`${_vm.cms.scroll_id}`}},[_c('grid',{class:['grid--container', `${_vm.name}__grid`],attrs:{"layout":[
      {
        size: 1,
        columns: 'repeat(12, 1fr)',
        gap: '0 6px',
      },
      {
        size: 2,
        columns: 'repeat(24, 1fr)',
        gap: '10px',
      },
    ]}},[_c('grid-item',{class:[`${_vm.name}__grid-item`, `${_vm.name}__filter-list`],attrs:{"layout":[
        { size: 1, x: 1, width: 12 },
        { size: 2, x: 1, width: 24 },
      ]}},[_c('m-filter-office',{class:`${_vm.name}__filter`,on:{"onOfficeFilterClick":_vm.onOfficeFilterClick}})],1)],1),_vm._v(" "),_c('grid',{class:['grid--container', `${_vm.name}__grid`],attrs:{"layout":[
      {
        size: 1,
        columns: 'repeat(12, 1fr)',
        gap: '0 6px',
      },
      {
        size: 2,
        columns: 'repeat(24, 1fr)',
        gap: '10px',
      },
    ]}},[_c('grid-item',{class:`${_vm.name}__grid-item`,attrs:{"layout":[
        { size: 1, x: 1, width: 12 },
        { size: 3, x: 1, width: 24 },
      ]}},[_c('div',{class:`${_vm.name}__offices`},_vm._l((_vm.filteredCollection),function(item,index){return _c(item.component,{directives:[{name:"editable",rawName:"v-editable",value:(item),expression:"item"}],key:index,tag:"component",class:`${_vm.name}__card`,attrs:{"cms":item}})}),1)])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }